import { useEffect, useState } from 'react';
import { getPrivilege } from '../api/workspace';
import { contentTypes } from '../Components/CommonFunctions/aliases';
import { getDbConnectionDetails } from '../api/dbConnection';

export const useDbConnection = (contentid: string, workspaceId: string) => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<{ message: string; code: number; isError: boolean } | null>(
    null,
  );
  useEffect(() => {
    if (!contentid || !workspaceId) {
      setError({ message: 'Content ID and Workspace ID are required', code: 400, isError: true });
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const [previlege, dbconnectionInfo] = await Promise.all([
          getPrivilege(workspaceId, contentTypes.DataConnection, contentid),
          getDbConnectionDetails(contentid, workspaceId),
        ]);
        if (previlege.isError) {
          throw new Error(previlege.message);
        }
        if (dbconnectionInfo.isError) {
          throw new Error(dbconnectionInfo.message);
        }
        setData({
          ...dbconnectionInfo.data,
          privilege: previlege.data?.levelId,
        });
      } catch (e: any) {
        setError({
          message: e.message ?? 'Error while fetching the data',
          code: e.code || 500,
          isError: true,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [contentid, workspaceId]);

  return { result: data, loading, error };
};
